// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-content-content-l2iBF {
  flex-grow: 1;
  margin-top: 16px;
  overflow: hidden;
}
`, "",{"version":3,"sources":["webpack://./../core/src/components/page-content/page-content.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB","sourcesContent":[".content {\n  flex-grow: 1;\n  margin-top: 16px;\n  overflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `page-content-content-l2iBF`
};
export default ___CSS_LOADER_EXPORT___;
